import { render, staticRenderFns } from "./PrintInvoicePreviewProforma.vue?vue&type=template&id=57c48990"
import script from "./PrintInvoicePreviewProforma.vue?vue&type=script&lang=js"
export * from "./PrintInvoicePreviewProforma.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports